




























import { Component, Vue } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import GroupListResult from '@/components/group/list/Result.vue';
import { formatApiError } from '@/utils/index';
import { translateRouteTitle } from '@/utils/permission';
import { AppModule } from '@/store/modules/app';
import { IGroup } from '@/api/types';
import { listGroups, IListGroupsRequest } from '@/api/users';

@Component({
  name: 'GroupList',
  components: {
    MaterialCard,
    GroupListResult,
  },
})
export default class extends Vue {
  private groups: IGroup[] = [];
  private searched = false;

  get canDisplayResult() {
    return this.groups && this.groups.length > 0;
  }

  get canDisplayNoData() {
    return (!this.groups || this.groups.length <= 0) && this.searched;
  }

  get noDataText() {
    return this.$t('No {msg}', {
      msg: (this.$t('Group') as string).toLowerCase(),
    });
  }

  mounted() {
    this.handleSearch({} as IListGroupsRequest);
  }

  private async handleSearch($event: any) {
    const req: IListGroupsRequest = $event;

    AppModule.StartProgress();
    try {
      const res = await listGroups(req);
      this.groups = res.groups;
      this.searched = true;
      AppModule.StopProgress();
    } catch (err) {
      this.searched = true;
      AppModule.StopProgress();
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.translateRouteTitle(
            this.$route.meta.title
          ) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
